module.exports = __webpack_public_path__ + "img/ageTech.e3db21ef.png";